import Vue from 'vue'
import * as types from '../mutation-types'
import helpers from '@/util/helpers'

// initial state
const state = {
  authors: [],
  authorsPagination: {},
  author: {}
}

// getters
const getters = {
  authors: state => state.authors,
  authorsPagination: state => state.authorsPagination,
  author: state => state.author
}

// actions
const actions = {
  getAuthors ({ state, commit }, args) {
    return Vue.axios.get(`/authors/`, {
      params: args.params,
      headers: args.headers || null
    }).then((response) => {
      commit(types.RECEIVE_AUTHOR_LIST, { response })
    })
  },
  getAuthor ({ state, commit }, args) {
    return Vue.axios.get(`/authors/${args.id}/`, {
      headers: args.headers || null
    }).then((response) => {
      commit(types.RECEIVE_AUTHOR, { response })
    })
  },
  createAuthor ({ state, commit }, args) {
    return Vue.axios.post(
      `/authors/`,
      args
    ).then((response) => {
      commit(types.RECEIVE_AUTHOR, { response })
    })
  },
  saveAuthor ({ state, commit }, args) {
    return Vue.axios.put(
      `/authors/${state.author.id}/`, state.author, {
      headers: args.headers || null
    }).then((response) => {
      commit(types.RECEIVE_AUTHOR, { response })
    })
  },
  deleteAuthor ({ state, commit }, args) {
    return Vue.axios.delete(`/authors/${args.id}/`, {
      headers: args.headers || null
    }).then((response) => {
      commit(types.RECEIVE_AUTHOR, { response })
    })
  },
  uploadAuthorPhoto ({ state, commit }, args) {
    return Vue.axios.post(`/authors/${args.id}/upload-photo/`,
      args.formEncodedData,
      {
        headers: args.headers || null
      }
    )
    .then(function (response) {
      commit(types.RECEIVE_AUTHOR, { response })
    })
  },
}

// mutations
const mutations = {
  [types.RECEIVE_AUTHOR] (state, { response }) {
    state.author = response.data.results
  },
  [types.RECEIVE_AUTHOR_LIST] (state, { response }) {
    state.authors = response.data.results
    state.authorsPagination = helpers.pagination(response.headers)
  },
  [types.UPDATE_AUTHOR_VALUE] (state, value) {
    state.author = Object.assign(state.author, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
